"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const native_1 = require("@react-navigation/native");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const icon_1 = __importDefault(require("../../components/icon/icon"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const styles_1 = __importDefault(require("../../styles/styles"));
const changePasswordComponent_1 = __importDefault(require("../../components/changePasswordComponent/changePasswordComponent"));
const profileInfoComponent_1 = __importDefault(require("../../components/profileInfoComponent/profileInfoComponent"));
const screenConstants_1 = require("../../constants/screenConstants");
const pressable_1 = __importDefault(require("../../components/pressable/pressable"));
const eventConstants_1 = require("../../constants/eventConstants");
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const Profile = () => {
    const { officer } = useAppSelector_1.default((state) => ({
        officer: state.auth.user,
    }));
    const isDesktop = useWebDesktopDesign_1.default();
    const navigator = native_1.useNavigation();
    const containerStyle = isDesktop ? styles_1.default.allScreenWeb : styles_1.default.allScreenMobile;
    const containerProfile = isDesktop ? [styles_1.default.flexDirectionRow] : [];
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: containerStyle },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                    react_1.default.createElement(boxTitle_1.default, { title: "Officer Profile" })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.flexOne] },
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(pressable_1.default, { onPress: () => navigator.navigate(screenConstants_1.DASHBOARD_SCREEN), style: [styles_1.default.flexDirectionRow, styles_1.default.alignCenterCenter], eventName: eventConstants_1.NAVIGATE_HOME_BUTTON },
                            react_1.default.createElement(react_native_1.View, null,
                                react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faArrowLeft })),
                            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                                react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlue }, ` Dashboard `)))))),
            react_1.default.createElement(react_native_1.View, { style: [containerProfile] },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.minHeight] },
                    react_1.default.createElement(profileInfoComponent_1.default, { officer: officer })),
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.minHeight] },
                    react_1.default.createElement(changePasswordComponent_1.default, null))))));
};
exports.default = Profile;
